<template>
  <div  style="height: 100%"> 
    <div  v-if="predeterminados.configuracion.predeterminados instanceof Array && cargado===1">
      <b-row  v-if="windowSize>=992" class="d-none d-md-block">
        <b-col :md="12" style="padding:0;height:65px">
          <sw-header @init="onInit">
          </sw-header> 
        </b-col>
        <b-col :md="12" style="padding:0;" >
          <b-row>
              <b-col style="padding:0; height: 100%;flex-basis:200px;flex-grow: 0;"  class="d-print-none">
                <sw-aside v-if="aside">
                </sw-aside> 
              </b-col>
              <b-col style="padding:0; height: 100%;">     
                <div class="body-sw">     
                  <div  v-show="loading" class="loading-capa">
                    <div class="i-wrapper loading-black"><i class="i-spinner i-spinner--light loading-i"></i></div>          
                  </div>        
                  <div class="blocksave" v-show="saveConfig.capa"></div>                  
                  <router-view class="animated fadeIn faster" > 
                  </router-view> 
                </div>  
              </b-col>
          </b-row>
        </b-col>     
      </b-row>
      <b-row  v-if="windowSize<992" class="d-block">
        <div class="blocksave" v-show="saveConfig.capa"></div>
        <b-col :md="12" style="padding:0;height:75px">
          <sw-header @init="onInit">
          </sw-header> 
        </b-col>
        <b-col style="padding:0; height: 100%; padding-bottom: 70px">     
          <div class="body-sw" style="padding:0 0 60px; margin-top:70px">     
            <div  v-show="loading" class="loading-capa">
              <div class="i-wrapper loading-black"><i class="i-spinner i-spinner--light loading-i"></i></div>          
            </div>        
            <router-view>
            </router-view> 
          </div>  
        </b-col>
      </b-row>
      <b-sidebar
        v-model="openMenuMovil"
        id="sidebar-backdrop"
        class="menu-movil-sidedar"
        no-header
        backdrop
        shadow
        width="200px"
        @hidden="updateGlobal({state: 'openMenuMovil', data: false })"
        >
          <sw-asidemovil style="padding-bottom:20px" v-if="aside">
          </sw-asidemovil> 
      </b-sidebar>
      <sw-notification></sw-notification>
    </div> 
    <div  v-if="cargado===0">      
        <div class="blocksave gradient-blocksave d-none md-block">  
           <b-row  style="height:70%" align-v="center">
              <b-col></b-col>
              <b-col class="text-center">
                <div style="width: 220px;position: relative;margin: auto;">
                  <img src="images/logo-load.svg">                  
                  <img src="images/minlogo-load.svg"  class="min-logo-load">
                </div>                
                <p>Hola {{user.name}}, estamos cargando la aplicación...</p>
                <b-button style="margin-top:20px" @click="logout" variant="link">Cerrar sesión</b-button>
                </b-col>
              <b-col></b-col>
            </b-row>
        </div>     
        <div class="blocksave gradient-blocksave  d-block md-none">    
          <b-row  style="height:70%" align-v="center">  
            <b-col class="text-center">      
              <div style="width: 220px;position: relative;margin: auto;">
                <img src="images/logo-load.svg">                  
                <img src="images/minlogo-load.svg"  class="min-logo-load">
              </div>                
              <p>Hola {{user.name}}, estamos cargando la aplicación...</p>
              <b-button style="margin-top:20px" class="btn btn-link text-danger" @click="logout" variant="link">Cerrar sesión</b-button>
            </b-col>
          </b-row>           
        </div>
    </div>            
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SwAside  from './aside.vue';
import SwAsidemovil  from './aside-movil.vue';
import SwHeader  from './header.vue';
import saveMixins  from '@/mixings/save.js'
import SwNotification  from '@/components/notification/swnotification.vue'

export default {
  name: "master-layout",  
  data () {
    return {
      aside: true,   
      cargado: 0,
      beetweenInicialshow: ''
    }
  },
  mixins: [saveMixins,],
  components: {
    SwAside,
    SwHeader,
    SwAsidemovil,
    SwNotification 
    
  },
  async created () {   
        await this.onInit()
  },
  computed: { 
    ...mapState({
      loading: state => state.globalStore.saveConfig.loading,
    })   
  },
  methods: {
    ...mapActions({      
        getDataList:  'crudStore/getDataList',  
        getDataMultiples:  'crudStore/getDataMultiples',  
        logout:     'authStore/logout',       
    }),
      
    async handleResize(){
       await this.updateGlobal({state: 'windowSize',data: window.innerWidth})
    },
    async onInit()
    {  
        this.cargado= 0
        let beetween=this.fecha().beetween
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
      
        const beetweenInicial = await this.buscarIdb({tabla: 'ultima_conexion', campo: 'id', value: 1})  
        
        if(beetweenInicial.length===0)
        { 
          const wait2 =  this.saveIdb({ultima_conexion: {id: 1, inicial: beetween.inicial, final: beetween.final}})
          const wait3 =  this.updateCrud({state: 'conection', data: {inicial: '2020-01-01', final: beetween.final}})
          await Promise.all([wait2,wait3])
        }
        else
        {
          await this.updateCrud({state: 'conection', data: beetweenInicial[0]})
        }

        // traer de la base de datos las lists_ y los datos_
          if(beetweenInicial.length===0)
          {      
            const wait4 = this.getDataConfig({route: 'get_config', data: {inicial: '2020-01-01', final: beetween.final}})
            const wait5 = this.getDataList({route: 'get_lists', data: {inicial: '2020-01-01', final: beetween.final}})
            const wait6 = this.getDataMultiples({route: 'get_multiples', data: {inicial: '2020-01-01', final: beetween.final}})
            const wait7 = this.saveIdb({ultima_conexion: {id: 1, inicial: beetween.inicial, final: beetween.final }})
            await Promise.all([wait4,wait5,wait6,wait7])
          }
          else{
            const wait8 =this.getDataConfig({route: 'get_config', data: {inicial:  beetweenInicial[0].inicial, final: beetween.final}})
            const wait9 =this.getDataList({route: 'get_lists', data: {inicial: '2020-01-01', final: beetween.final}})
            const wait10 =this.getDataMultiples({route: 'get_multiples', data: {inicial: beetweenInicial[0].inicial, final: beetween.final}})
            const wait11 =this.saveIdb({ultima_conexion: {id: 1, inicial: beetween.inicial, final: beetween.final }})
            await Promise.all([wait8,wait9,wait10,wait11])
          }
          const wait12 = this.updateCrud({state: 'conection', data: {inicial:  beetween.inicial, final: beetween.final}})

        let searchsKeys = Object.keys(this.lists)
        let newSwSearchs= {}
        for (let i = 0; i < searchsKeys.length; i++) {

          newSwSearchs[searchsKeys[i]] = null;      
        }
        const wait13 =  this.updateCrud({state: 'swSearchs', data: newSwSearchs})
        await Promise.all([wait12,wait13]) 
        this.cargado= 1
    },
    async cargarBasededatos() 
    {
        let dataSave = {     
                  list_documento  : [
                          { id: null, name: 'CC'},
                          { id: null, name: 'CE'},
                          { id: null, name: 'PE'},
                          { id: null, name: 'TI'},
                          { id: null, name: 'NI'},
                  ],  
                  list_eps: [
                          { id: null, name: 'ALIANSALUD', codigo: 'EPS001'},
                          { id: null, name: 'SALUD TOTAL S.A.', codigo: 'EPS002'},
                          { id: null, name: 'CAFESALUD', codigo: 'EPS003'},
                          { id: null, name: 'SANITAS S.A.', codigo: 'EPS005'},
                          { id: null, name: 'COMPENSAR', codigo: 'EPS008'},
                          { id: null, name: 'EPS-SURA', codigo: 'EPS010'},
                          { id: null, name: 'COMFENALCO VALLE E.P.S.', codigo: 'EPS012'},
                          { id: null, name: 'SALUDCOOP', codigo: 'EPS013'},
                          { id: null, name: 'COOMEVA S.A.', codigo: 'EPS016'},
                          { id: null, name: 'FAMISANAR', codigo: 'EPS017'},
                          { id: null, name: 'S.O.S. E.P.S', codigo: 'EPS018'},
                          { id: null, name: 'CRUZ BLANCA S.A.', codigo: 'EPS023'},
                          { id: null, name: 'SALUDVIDA S.A.', codigo: 'EPS033'},
                          { id: null, name: 'NUEVA EPS S.A', codigo: 'EPS037'},
                          { id: null, name: 'GOLDEN CROSS EPS S. A.', codigo: 'EPS039'},
                          { id: null, name: 'FOSYGA', codigo: 'MIN001'},
                          { id: null, name: 'ECOOPSOS', codigo: 'ESSC91'},
                          { id: null, name: 'MUTUAL SER', codigo: 'ESSC07'},
                          { id: null, name: 'CAFAM EPS', codigo: 'CCFC18'},
                          { id: null, name: 'AMBUQ', codigo: 'ESSC76'},
                          { id: null, name: 'COMFAMILIAR DE NARIÑO EPS', codigo: 'CCFC27'},
                          { id: null, name: 'MALLAMAS', codigo: 'EPSIC5'},
                          { id: null, name: 'PIJAOSALUD EPS', codigo: 'EPSIC6'},
                          { id: null, name: 'ASMET SALUD ESS', codigo: 'ESSC62'},
                          { id: null, name: 'EPS-S COMF HUILA', codigo: 'CCFC24'},
                          { id: null, name: 'EPS-S  COMFACOR', codigo: 'CCFC15'},
                          { id: null, name: 'EPS-S CAJACOPI', codigo: 'CCFC55'},
                          { id: null, name: 'EPS-S  CONVIDA', codigo: 'EPSC22'},
                          { id: null, name: 'SAVIA SALUD EPS', codigo: 'EPSTC1'},
                          { id: null, name: 'EPS CAPRECOM', codigo: 'EPSC20'},
                          { id: null, name: 'EMSSANAR E.S.S.', codigo: 'ESSC18'},
                          { id: null, name: 'EPS-S COOSALUD', codigo: 'ESSC24'},
                          { id: null, name: 'COLSUBSIDIO EPS', codigo: 'CCFC10'},
                          { id: null, name: 'EPS-S COMFACUNDI', codigo: 'CCFC53'},
                          { id: null, name: 'CAPRESOCA EPS', codigo: 'EPSC25'},
                          { id: null, name: 'CAPITAL SALUD', codigo: 'EPSC34'},
                          { id: null, name: 'ZENU', codigo: 'EPSIC2'},
                          { id: null, name: 'ENDISALUD ESS', codigo: 'ESSC02'},
                          { id: null, name: 'EPS-S COMPARTA', codigo: 'ESSC33'},
                          { id: null, name: 'SIN ASIGNAR', codigo: '000000'},
                          { id: null, name: 'MEDIMAS', codigo: 'EPS044'},
                          { id: null, name: 'SALUD MIA EPS', codigo: 'EPS046'},
                          { id: null, name: 'FONDO PASIVO SOCIAL FERROCARRILES', codigo: 'EAS027'},
                          { id: null, name: 'COMFASUCRE', codigo: 'CCFC33'},
                  ],
                  list_riesgo: [
                          { id: null, name: '1'},
                          { id: null, name: '2'},
                          { id: null, name: '3'},
                          { id: null, name: '4'},
                          { id: null, name: '5'},
                  ],                 
                  list_arl: [
                          { id: null, name: 'COLPATRIA', codigo: '14-4'},
                          { id: null, name: 'BOLIVAR S.A.', codigo: '14-7'},
                          { id: null, name: 'AURORA', codigo: '14-8'},
                          { id: null, name: 'ALFA S.A.', codigo: '14-17'},
                          { id: null, name: 'LIBERTY', codigo: '14-18'},
                          { id: null, name: 'POSITIVA', codigo: '14-23'},
                          { id: null, name: 'COLMENA S.A', codigo: '14-25'},
                          { id: null, name: 'ARL- SURA', codigo: '14-11'},
                          { id: null, name: 'LA EQUIDAD', codigo: '14-29'},
                          { id: null, name: 'MAPFRE S.A.', codigo: '14-30'},
                          { id: null, name: 'PREVISORA VIDA S.A.', codigo: '25-10'},
                  ],
                  list_ccf: [
                          { id: null, name: 'CAMACOL', codigo: 'CCF02'},
                          { id: null, name: 'COMFENALCO ANTIOQUIA', codigo: 'CCF03'},
                          { id: null, name: 'COMFAMA ANTIOQUIA', codigo: 'CCF04'},
                          { id: null, name: 'CAJACOPI ATLANTICO', codigo: 'CCF05'},
                          { id: null, name: 'COMBARRANQUILLA', codigo: 'CCF06'},
                          { id: null, name: 'COMFAMILIAR DEL ATLANTICO', codigo: 'CCF07'},
                          { id: null, name: 'COMFENALCO CARTAGENA', codigo: 'CCF08'},
                          { id: null, name: 'CCF DE CARTAGENA', codigo: 'CCF09'},
                          { id: null, name: 'COMFABOY', codigo: 'CCF10'},
                          { id: null, name: 'CCF DE CALDAS', codigo: 'CCF11'},
                          { id: null, name: 'COMFACA', codigo: 'CCF13'},
                          { id: null, name: 'COMFACAUCA', codigo: 'CCF14'},
                          { id: null, name: 'COMFACESAR', codigo: 'CCF15'},
                          { id: null, name: 'COMFACOR', codigo: 'CCF16'},
                          { id: null, name: 'CAFAM', codigo: 'CCF21'},
                          { id: null, name: 'COLSUBSIDIO', codigo: 'CCF22'},
                          { id: null, name: 'COMPENSAR', codigo: 'CCF24'},
                          { id: null, name: 'COMFACUNDI', codigo: 'CCF26'},
                          { id: null, name: 'COMFENALCO SANTANDER', codigo: 'CCF40'},
                          { id: null, name: 'NINGUNA', codigo: '000000'},
                          { id: null, name: 'ASFAMILIAS', codigo: 'CCF20'},
                          { id: null, name: 'COMCAJA', codigo: 'CCF68'},
                          { id: null, name: 'COMFAUNION', codigo: 'CCF61'},
                          { id: null, name: 'CAUCACOMFENALCO VALLE', codigo: 'CCF56'},
                          { id: null, name: 'CONFIAR', codigo: 'CCF67'},
                          { id: null, name: 'CAFABA', codigo: 'CCF38'},
                          { id: null, name: 'CCF DE BUENAVENTURA', codigo: 'CCF51'},
                          { id: null, name: 'COMFACARTAGO', codigo: 'CCF59'},
                          { id: null, name: 'COMFENALCO CUNDINAMARCA', codigo: 'CCF23'},
                          { id: null, name: 'COMFENALCO QUINDIO', codigo: 'CCF43'},
                          { id: null, name: 'COMFENALCO TOLIMA', codigo: 'CCF50'},
                          { id: null, name: 'COMFAMILIAR LA DORADA', codigo: 'CCF12'},
                          { id: null, name: 'COMFAGIRARDOT', codigo: 'CCF28'},
                          { id: null, name: 'CCF FAMILIAR DEL CHOCO', codigo: 'CCF29'},
                          { id: null, name: 'CCF FAMILIAR LA GUAJIRA', codigo: 'CCF30'},
                          { id: null, name: 'CCF FAMILIAR DEL HUILA', codigo: 'CCF32'},
                          { id: null, name: 'CCF FAMILIAR DEL MAGDALENA', codigo: 'CCF33'},
                          { id: null, name: 'COFREM', codigo: 'CCF34'},
                          { id: null, name: 'CCF FAMILIAR NARIÑO', codigo: 'CCF35'},
                          { id: null, name: 'CCF FAMILIAR DEL ORIENTE', codigo: 'CCF36'},
                          { id: null, name: 'COMFANORTE COMFAORIENTE', codigo: 'CCF37'},
                          { id: null, name: 'CAJASAN', codigo: 'CCF39'},
                          { id: null, name: 'CCF FAMILIAR DEL SUCRE', codigo: 'CCF41'},
                          { id: null, name: 'CCF FAMILIAR DEL QUINDIO', codigo: 'CCF42'},
                          { id: null, name: 'COMFAMILIAR RISARALDA', codigo: 'CCF44'},
                          { id: null, name: 'COMFAHONDA', codigo: 'CCF47'},
                          { id: null, name: 'COMFATOLIMA', codigo: 'CCF48'},
                          { id: null, name: 'COMFANDI', codigo: 'CCF57'},
                  ],
                  list_afp: [
                          { id: null, name: 'PROTECCIÓN', codigo: '230201'},
                          { id: null, name: 'PORVENIR', codigo: '230301'},
                          { id: null, name: 'SKANDIA', codigo: '230901'},
                          { id: null, name: 'SKANDIA ALTERNATIVO', codigo: '230904'},
                          { id: null, name: 'COLFONDOS', codigo: '231001'},
                          { id: null, name: 'PENSIONES DE ANTIOQUIA', codigo: '25-7'},
                          { id: null, name: 'COLPENSIONES', codigo: '25-14'},
                          { id: null, name: 'MAPFRE S.A. ', codigo: '14-30'},
                          { id: null, name: 'PREVISORA VIDA S.A.', codigo: '25-10'},
                          { id: null, name: 'I.SS.FSP', codigo: 'ISSFSP'},
                          { id: null, name: 'SIN ASIGNAR', codigo: '0000000'},
                  ],
                  list_tipo: [
                          { id: null, codigo: 3,  name: 'Independiente', filter: [1]},
                          { id: null, codigo: 43, name: 'Independiente voluntario al sistema de riesgos laborales', filter: [1]},
                          { id: null, codigo: 1,  name: 'Dependiente', filter: [0]},
                          { id: null, codigo: 8,  name: 'Aprendices en etapa lectiva', filter: [0]},
                          { id: null, codigo: 14, name: 'Funcionarios públicos sin tope máximo en el IBC', filter: [0]},
                          { id: null, codigo: 15, name: 'Aprendices en etapa productiva', filter: [0]},
                          { id: null, codigo: 16, name: 'Estudiantes', filter: [0]},
                          { id: null, codigo: 17, name: 'Estudiantes de posgrado en salud', filter: [0]},
                          { id: null, codigo: 18, name: 'Profesor de establecimiento particular', filter: [0]},
                          { id: null, codigo: 44, name: 'Estudiantes decreto 055', filter: [0]},
                          { id: null, codigo: 33, name: 'Beneficiario de UPC adicional', filter: [0]},
                          { id: null, codigo: 37, name: 'Trabajador de tiempo parcial', filter: [0]},
                          { id: null, codigo: 48, name: 'Prepensionado de entidad en liquidación', filter: [0]},
                          { id: null, codigo: 47, name: 'Independiente con contrato de prestación de servicios superior a 1 mes', filter: [0]}
                  ], 
                  list_subtipo: [
                          { id: null, codigo: 0, name: 'Ninguno', filter: [1,3,2,3,4,5,6,7,8,9,10,11,12,13,14]},
                          { id: null, codigo: 8, name: 'Dependiente pensionado activo', filter: [3,3,4,5,6,7,8,9,10,11,12,13]},
                          { id: null, codigo: 3, name: 'Cotizante no obligado a cotizar pensioón por edad', filter: [1,3,2,4,5,6,7,8,9,10,11,12,13,14]},
                          { id: null, codigo: 4, name: 'Cotizante con requisitos cumplidos para pensión', filter: [1,3,2,4,5,6,7,8,9,10,11,12,13,14]},
                          { id: null, codigo: 5, name: 'Cotizante indenmización sustituvia o devolución de saldos', filter: [1,3,2,4,5,6,7,8,9,10,11,12,13,14]},
                          {id: null, codigo: 11, name: 'Taxista', filter: [2]},
                          {id: null, codigo: 12, name: 'Taxista no obligados a cotizar pensión', filter: [2]}
                  ],  
                  list_forma: [
                          { id: null, name: 'Consignación'},
                          { id: null, name: 'Crédito'},
                          { id: null, name: 'Cruze Asesor'},
                          { id: null, name: 'Efectivo'},
                          { id: null, name: 'Mensajeria'},
                          { id: null, name: 'Prestamo'},
                          { id: null, name: 'Cheque'},
                  ],  
                  list_cuentas: [
                          { id: null, name: 'Ahorro a la mano'},
                          { id: null, name: 'Bancolombia'},
                          { id: null, name: 'Daviplata'},
                          { id: null, name: 'Davivienda'},
                          { id: null, name: 'Efecty'},
                          { id: null, name: 'Nequi'},
                  ],  
                  list_servicios: [
                          { id: null, name: 'EPS',list: 'list_eps'},
                          { id: null, name: 'ARL',list: 'list_arl'},
                          { id: null, name: 'AFP',list: 'list_afp'},
                          { id: null, name: 'CCF',list: 'list_ccf'},
                  ],  
                  list_estado: [
                          { id: null, name: 'Activo'},
                          { id: null, name: 'Inactivo'},
                  ],     
                  datos_asesor: [
                          { id: null, name: 'Oficina', documento: 1, email:null, telefonos:null, r1:0,r2:0,r3:0,r4:0,r5:0,ccf:0,afp:0,comision:0,admin:0},
                  ],
                  datos_razon: [
                          { id: null, name: 'Independiente', id_list_arl: 8, id_list_ccf: 20 ,id_list_documento:1, documento: '0',dv:'0',id_list_arl:1,id_list_ccf:1,direccion:null,telefonos:null,email: null,exonerado:0},
                    ],
                  datos_contacto: [
                          { id: null, name: 'Principal', documento: '1095950514', direccion:'Cra 28 # 9-61', email:'pikeryuk@gmail.com', telefonos:'3162520642'},
                  ],  
                  multiple_servicios: [
                    { id: null, name: 'Eps', id_list: 1 , name_list: 'list_eps',  afiliacion: 0, valor: 0, porcentaje: 4, check:0, lock: 1, disabled: 0, view: 0},
                    { id: null, name: 'Riesgo', id_list: 1 , name_list: 'list_riesgo',  afiliacion: 0, valor: 0, porcentaje: 4, check:0, lock: 1, disabled: 0, view: 0},
                    { id: null, name: 'Ccf', id_list: 1 , name_list: 'list_ccf',  afiliacion: 0, valor: 0, porcentaje: 4, check:0, lock: 1, disabled: 0, view: 0},
                    { id: null, name: 'Afp', id_list: 1 , name_list: 'list_afp',  afiliacion: 0, valor: 0, porcentaje: 4, check:0, lock: 1, disabled: 0, view: 0},
                    { id: null, name: 'Traslado', id_list: 1 , name_list: 'list_eps',  afiliacion: 0, valor: 0, porcentaje: null, check:0, lock: 0, disabled: 0, view: 0},
                    { id: null, name: 'Administración', id_list: 1 , name_list: null,  afiliacion: 0, valor: 0, porcentaje: null, check:1, lock: 0, disabled: 1, view: 0},
                  ]
        }
        await this.updateDataPost({ state: 'route', data: 'save_all'})
        await this.updateDataPost({ state: 'tablaAuditar', data: true})
        await this.pushDataPost({ state: 'data', data: dataSave })
        await this.updateDataPost({ state: 'tablaDelete', data: []})

        await this.save(false,true)

        return true
    }
  }
};
</script>
<style>
.option-btn {
  cursor:pointer
}
.body-sw{
  padding: 50px;
}
.card-body{
  padding: 10px 
}
.title-form{
   border-bottom: 1px solid rgba(85, 85, 85, .6); 
   padding-bottom:10px;
   margin:30px 0 10px;
   color:#555
}
.form-control{
  
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}
:focus {
    outline: none;
}
.box-effect.linear {
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
}
.is-invalid{
  background-image: none !important
}
.btn.disabled {
  cursor: no-drop;
}
.col-form-label{  
    padding-bottom: 3px !important;
    color: rgb(85, 85, 85);
}
.header-card{
   text-align: center;
   font-weight: 600;
   font-size: 20px;
   
 }
.row{
  margin-left: 0;
  margin-right: 0;
}
.menu-movil-sidedar .b-sidebar {
  padding-top:0 !important;
}
.blocksave{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0px;
  background: rgba(255,255,255,.7);
  z-index: 1000;
}
.gradient-blocksave{
  background: rgba(247,252,255,1);
  background: -moz-linear-gradient(left, rgba(247,252,255,1) 0%, rgba(218,237,250,1) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgba(247,252,255,1)), color-stop(100%, rgba(218,237,250,1)));
  background: -webkit-linear-gradient(left, rgba(247,252,255,1) 0%, rgba(218,237,250,1) 100%);
  background: -o-linear-gradient(left, rgba(247,252,255,1) 0%, rgba(218,237,250,1) 100%);
  background: -ms-linear-gradient(left, rgba(247,252,255,1) 0%, rgba(218,237,250,1) 100%);
  background: linear-gradient(to right, rgba(247,252,255,1) 0%, rgba(218,237,250,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f7fcff', endColorstr='#daedfa', GradientType=1 );
}
.modalsave{
  position: absolute;
  width: 100%;
  height: calc(100% + 65px);
  top: -64px;;
  left: 0px;
  background: rgba(255,255,255,.7);
  z-index: 1046;
  border-radius: 5px;
}
.min-logo-load { 
  right:25px;
  top: 54px;
  position: absolute;
  animation: spin-around 3500ms infinite linear;
}
.loading-btn
{
  position: relative;
  color: transparent !important;
}
.loading-btn-active
{
    position: absolute;
    right: 0;
    z-index: 17;
}
.loading-btn:after
{
  
  border-left-color: #fff !important;
  border-bottom-color: #fff !important;
  animation: spin-around 500ms infinite linear;
  border: 2px solid #888888;
  border-radius: 50%;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 16px;
  width: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -8px;
  margin-top: -8px;
}
.border-edit{
  border-color: rgba(0,123,255,0.5) 
}
.opacity-save{
  opacity: 0.7
}
.btn:focus, .btn.focus{
 box-shadow:inherit
}
.dropdown-item.active, .dropdown-item:active{
  background-color: #563d7c;
}
.text-inactive{
  color: #E66B32 !important
}
.bg-sw-inactive{
  background: #737575 !important
}
.bg-sw-nuevo{
  background: #60438A;
}
.sw-md{
  width: 800px !important
}
.btn-outline-modal{  
    color: #8C63C9 !important;
    border-color: #8C63C9 !important;
}
.btn-outline-modal:hover{  
    color: white !important;
    background-color: #60438A !important;
}
.popover.b-popover{
  max-width: 800px
}
.custom-checkbox label{
  justify-content: initial !important;
}
.title-form.subtitle-form{
  font-size:18px;
}
.multiselect__tag{
  background-color: #17a2b8 !important;
  border:none !important
}
.multiselect__tag-icon{
  border:none !important;
  font-size: 16px;
  padding: 3px 4px;
}
@-webkit-keyframes spin-around {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg); }
  to {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg); } }

@keyframes spin-around {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg); }
  to {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg); } }
.input-group > .form-control, .input-group > .form-control-plaintext, .input-group > .custom-select, .input-group > .custom-file 
{
  flex: 1 1;
}
.input-group
{
  flex-wrap:inherit;
} 
.filter-sw-group
{
  margin-top:10px !important;
}
.multiselect__option--highlight
{
  background: #eaeaea !important;
}
@media only screen and (max-width: 992px) 
{
  .card-body{
    padding-left:0 !important;
    padding-right: 0 !important;
  }
}
.bv-no-focus-ring
{
  width:100%
}
</style>
